export default {
      id: "common__add_sm-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__add_sm",
      toString: function () {
        return this.url;
      }
    }